var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnalyticsNavIcon = function SvgAnalyticsNavIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FBD15D",
    d: "M11 4a2 2 0 1 1 4 0v14a2 2 0 1 1-4 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4AA2C4",
    d: "M16 12a2 2 0 1 1 4 0v6a2 2 0 1 1-4 0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA3556",
    d: "M6 9a2 2 0 1 1 4 0v9a2 2 0 1 1-4 0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8C2E89",
    d: "M1 12a2 2 0 1 1 4 0v6a2 2 0 1 1-4 0z"
  })));
};
export default SvgAnalyticsNavIcon;